import React, {useContext, useEffect, useRef, useState} from 'react';
import {Button, Form, Input, Popconfirm, Select, Table} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import TextArea from "antd/es/input/TextArea";

const EditableContext = React.createContext(null);

const EditableRow = ({index, ...props}) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);
    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <TextArea ref={inputRef} onPressEnter={save} onBlur={save}/>
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};
const ExtraInfoTable = ({info, setInfo, machines}) => {
    const [count, setCount] = useState(2);
    const [selectedMachine, setSelectedMachine] = useState('')
    const handleDelete = (key) => {
        const newData = info.filter((item) => item.key !== key);
        setInfo(newData);
    };
    const defaultColumns = [
        {
            title: 'Component',
            dataIndex: 'component',
            width: '35%',
            editable: false,
        },
        {
            title: 'Additional info',
            dataIndex: 'info',
            width: '55%',
            editable: true,
        },
        {
            title: '',
            dataIndex: '',
            render: (_, record) =>
                info.length >= 1 ? (
                    <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                        <DeleteOutlined/>
                    </Popconfirm>
                ) : null,
        },
    ];
    const handleAdd = () => {
        const newData = {
            key: count,
            component: selectedMachine,
            info: 'Click to edit'
        };
        setInfo([...info, newData]);
        setCount(count + 1)
        setSelectedMachine('');
    };
    const handleSave = (row) => {
        const newData = [...info];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setInfo(newData);
    };
    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={info}
                columns={columns}
                footer={() =>
                    <div className={'d-inline-flex w-100'}>
                        <div className={'w-50'}>
                            <Select className={'w-75'} onChange={setSelectedMachine} value={selectedMachine}>
                                <Select.Option value="">Select a component</Select.Option>
                                {machines.map((machine, idx) => {
                                    return <Select.Option
                                        key={idx}
                                        value={machine}
                                        disabled={info.find(info => info.component === machine) !== undefined}
                                    >
                                        {machine}
                                    </Select.Option>
                                })
                                }
                            </Select>
                        </div>
                        <div className={'w-50 d-inline-flex justify-content-end'}>
                            <Button
                                onClick={handleAdd}
                                type="primary"
                                disabled={selectedMachine === ''}
                            >
                                Add a information
                            </Button>
                        </div>
                    </div>
                }
            />
        </div>
    );
};
export default ExtraInfoTable;